import { useEffect, useState } from 'react';
import './header.css';
import Logo from '../logo/Logo';
import { Link, useLocation } from "react-router-dom";
import HamburgerMenu from '../hamburger/HamburgerMenu';
import { useViewportDevice } from '../../hooks/useViewportDevice';
import { useLinkDestination } from '../../hooks/useLinkDestination';
import LavoraConNoiMobile from '../lavoraConNoiMobile/LavoraConNoiMobile';

const Header = (props) => {

    /* ---- props ---- */
    const {
        links,
        setLinks,
        setShowModal,
        isUserOnGalleria,
        setIsUserOnGalleria
    } = props;

    /* ---- useState() ---- */
    const [mobileMenu, setMobileMenu] = useState(false);
    const [lavoraConNoiMobile, setLavoraConNoiMobile] = useState(false);

    /* --- React Router --- */
    const location = useLocation();
    const onGallery = location.pathname.startsWith("/galleria");

    /* ------ hooks ------ */
    const { isDesktop } = useViewportDevice();
    const getLinkDestination = useLinkDestination();

    const stopScroll = () => {
        const scrollTop  = window.scrollY;
        const scrollLeft = window.scrollX;

        window.onscroll = function() {
            window.scrollTo(scrollLeft, scrollTop);
        };
    };
    const getClassName = (btn) => {
        if (!btn?.hasFocused) {
            return btn?.id === 4 ? "galleria-btn" : "btn";
        } else {
            return btn?.id === 4 ? "galleria-btn-focused" : "btn";
        }
    };
    const getWidthLinkContainer = () => {
        if (isDesktop) {
            return isUserOnGalleria ? "45%" : "60%";
        }
    };
    const scrollToSection = (event, btn, index) => {
        if (index !== 4) {
            event.preventDefault();
            window.scrollTo({
                top      : document.querySelector(btn?.target)?.offsetTop,
                behavior : 'smooth'
            });
        }
    };
    const focusGalleriaBtn = (id) => {
        const updatedLinks = links?.map(link => {
            if (link?.id === id) {
                return { ...link, hasFocused: true };
            } else {
                return { ...link, hasFocused: false };
            }
        });
        setLinks(updatedLinks);
    };
    const handleOnClick = (event, btn) => {
        if (btn?.id !== 2) {

            focusGalleriaBtn(btn?.id);
            scrollToSection(event, btn, btn?.id);

        } else {

            const scrollTop  = window.scrollY;
            const scrollLeft = window.scrollX;

            window.onscroll = function() {
                window.scrollTo(scrollLeft, scrollTop);
            };

            setShowModal(true);
        }
    };

    /* ------ useEffect() ------ */
    useEffect(() => {
        if (lavoraConNoiMobile || mobileMenu) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "auto";
        }
        setIsUserOnGalleria(onGallery);
    }, [onGallery, setIsUserOnGalleria, lavoraConNoiMobile, mobileMenu]);

    return (
        <>
            {mobileMenu && (
                <HamburgerMenu
                    setMobileMenu={setMobileMenu}
                    isUserOnGalleria={isUserOnGalleria}
                    setLavoraConNoiMobile={setLavoraConNoiMobile}
                />
            )}

            {lavoraConNoiMobile && (
                <LavoraConNoiMobile
                    setLavoraConNoiMobile={setLavoraConNoiMobile}
                />
            )}

            <div className="header">

                <Logo header={true} links={links} setLinks={setLinks} />

                <div className="links-container" style={{ width: getWidthLinkContainer() }}>
                    {links?.map(link => (
                        <div key={link?.id} onClick={(e) => handleOnClick(e, link)}>
                            <Link
                                to={getLinkDestination(link)}
                                className={getClassName(link)}
                            >
                                {link?.section}
                            </Link>
                        </div>
                    ))}
                </div>

                <ShowIcon setMobileMenu={setMobileMenu} stopScroll={stopScroll} />

            </div>
        </>
    );
}

export default Header;

const ShowIcon = ({ setMobileMenu, stopScroll }) => {
    return (
        <span
            className="material-icons hamburger"
            onClick={() => {
                setMobileMenu(true);
                stopScroll();
            }}
        >
            menu
        </span>
    );
};